"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpIconButtonMenu = void 0;
const index_1 = require("../../enums/asset/index");
exports.helpIconButtonMenu = [
    {
        title: 'Game design',
        list: [
            {
                title: 'Start background image',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_DESIGN}#${index_1.HelpIconType.START_BACKGROUND_IMAGE}`,
            },
            {
                title: 'Sprite sheet',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_DESIGN}#${index_1.HelpIconType.SPRITE_SHEET}`,
            },
            {
                title: 'High score',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_DESIGN}#${index_1.HelpIconType.HIGH_SOCRE}`,
            },
            {
                title: 'Quiz',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_DESIGN}#${index_1.HelpIconType.QUIZE}`,
            },
        ],
    },
    {
        title: 'Game setting',
        list: [
            {
                title: 'Split games',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.SPLIT_GAMES}`,
            },
            {
                title: 'Instruction view',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.INSTRUCTION_VIEW}`,
            },
            {
                title: 'Views',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.VIEWS}`,
            },
            {
                title: 'Additional terms',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.ADDITIONAL_TERMS}`,
            },
            {
                title: 'Prizes',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.PRIZES}`,
            },
            {
                title: 'Winners - Prizes',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.WINNER_PRIZES}`,
            },
            {
                title: 'Challenge',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.CHALLENGE}`,
            },
            {
                title: 'Reward type',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.REWARD_TYPE}`,
            },
            {
                title: 'Challenge - Unique identifier',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.CHALLENGE_UNIQUE_IDENTIFIER}`,
            },
            {
                title: 'Reward in game',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.REWARD_IN_GAME}`,
            },
            {
                title: 'Multi entry',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.MULTI_ENTRY}`,
            },
            {
                title: 'Build User Base',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.BUILD_USER_BASE}`,
            },
            {
                title: 'User Base - Unique identifier',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.USER_BASE_UNIQUE_IDENTIFIER}`,
            },
            {
                title: 'Parameter',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.PARAMETER}`,
            },
            {
                title: 'Activate Luck Based Wins',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.LUCK_BASED_WINS_ACTIVATE}`,
            },
            {
                title: 'Score Condition',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.LUCK_BASED_WINS_SCORE_CONDITION}`,
            },
            {
                title: 'Luck Based Winner - Reward Type',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.LUCK_BASED_WINS_REWARD_TYPE}`,
            },
            {
                title: 'Chance To Win',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.LUCK_BASED_WINS_CHANCE_TO_WIN}`,
            },
            {
                title: 'Reward Limit',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.LUCK_BASED_WINS_REWARD_LIMIT}`,
            },
            {
                title: 'Popup',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_SETTING}#${index_1.HelpIconType.LUCK_BASED_WINS_POPUP}`,
            },
        ],
    },
    {
        title: 'Game Center settings',
        list: [
            {
                title: 'Activate wallet',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_CENTER_SETTINGS}#${index_1.HelpIconType.ACTIVE_WALLET}`,
            },
            {
                title: 'Build User Base',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_CENTER_SETTINGS}#${index_1.HelpIconType.USER_BASE_AND_LOGIN_BUILD_USER_BASE}`,
            },
            {
                title: 'Build User Base with identifier',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_CENTER_SETTINGS}#${index_1.HelpIconType.BUILD_USER_BASE_WITH_IDENTIFIER}`,
            },
            {
                title: 'Parameters',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.GAME_CENTER_SETTINGS}#${index_1.HelpIconType.PARAMETER}`,
            },
        ],
    },
    {
        title: 'Modules',
        list: [
            {
                title: 'Game module',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.MODULES}#${index_1.HelpIconType.GAME_MODULE}`,
            },
            {
                title: 'Text module',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.MODULES}#${index_1.HelpIconType.TEXT_MODULE}`,
            },
            {
                title: 'AD module',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.MODULES}#${index_1.HelpIconType.AD_MODULE}`,
            },
            {
                title: 'Reward module',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.MODULES}#${index_1.HelpIconType.REWARD_MODULE}`,
            },
        ],
    },
    {
        title: 'Receipt',
        list: [
            {
                title: 'General - Player Indentifier',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.RECEIPT}#${index_1.HelpIconType.GENERAL_PLAYER_IDENTIFIER}`,
            },
            {
                title: 'General - Additional Terms Text',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.RECEIPT}#${index_1.HelpIconType.GENERAL_ADDITIONAL_TERMS_TEXT}`,
            },
            {
                title: 'Conditions',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.RECEIPT}#${index_1.HelpIconType.CONDITIONS}`,
            },
            {
                title: 'Products',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.RECEIPT}#${index_1.HelpIconType.PRODUCTS}`,
            },
            {
                title: 'Stores',
                SK: `${index_1.HelpIconKeyType.SK}${index_1.HelpIconCategoryType.RECEIPT}#${index_1.HelpIconType.STORES}`,
            },
        ],
    },
];
